"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
_vue.default.component('tabbed-tab', {
  props: {
    header: {
      status: String
    },
    focus: {
      status: Boolean
    },
    name: {
      status: String
    }
  },
  data() {
    return {
      active: false
    };
  },
  template: '<div v-if="active" class="u-tabbed-content"><slot></slot></div>'
});
var _default = exports.default = _vue.default.component('tabbed-view', {
  props: {
    value: String,
    showTabs: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // We increment this when we need to re-render the tabs.
      // Vue doesn't pick up on the $children changes all the time so we handle
      // it ourselves.
      a: 1,
      prefixID: Math.floor(Math.random() * 100000).toString(36)
    };
  },
  computed: {
    tabs: function computedtabs() {
      return this.$children;
    }
  },
  watch: {
    value(newValue) {
      this.setActiveByName(newValue);
    }
  },
  mounted() {
    this.setActiveCheck();
  },
  methods: {
    getActive: function getActive() {
      let foundChild = null;
      this.$children.forEach(child => {
        if (child.active) {
          foundChild = child;
        }
      });
      return foundChild;
    },
    setActive: function setActive(c) {
      this.$children.forEach(child => {
        if (child !== c) {
          child.active = false;
        }
      });
      c.active = true;

      // Without this, vue doesnt update itself with the new $children :(
      this.a++;
      this.$emit('changed', c.name);
      this.$emit('input', c.name);
    },
    setActiveByName: function setActiveByName(name) {
      this.$children.forEach(child => {
        if (child.name === name) {
          this.setActive(child);
        }
      });
    },
    setActiveCheck: function setActiveCheck() {
      this.$children.forEach(t => {
        if (t.focus || t.name === this.value) {
          this.setActive(t);
        }
      });
    }
  }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["TabbedView"]
window._kiwi_exports.components.utils.TabbedView = exports.default ? exports.default : exports;
